import React from 'react'
import Yotpo from '../../../components/Yotpo';
import ProductInfoTitle from '../ProductFirstScreen/ProductInfo/ProductInfoTitle';

const ProductInfoTitleStandard = ({
  product,
  productsList,
  allBaseColours,
  withShadeShot,
  shots,
  shadeShotsProducts,
  sellingPlanGroup,
  miracleSystem,
  rating,
  scrollToReviews,
  isMobile
}) => (
  <section
    id="product-info-title-section"
    style={{ marginBottom: isMobile ? '16px' : '0px' }}
  >
    <ProductInfoTitle
      product={product}
      productsList={productsList}
      allBaseColours={allBaseColours}
      withShadeShot={withShadeShot}
      shots={shots}
      shadeShotsProducts={shadeShotsProducts}
      sellingPlanGroup={sellingPlanGroup}
      miracleSystem={miracleSystem}
    />

    {rating && (
      <Yotpo
        rating={rating}
        scrollToReviews={scrollToReviews}
        showCount
      />
    )}
  </section>
)


export default ProductInfoTitleStandard;
